export const centsToDollarsConversion = {
    convertCentsToDollars: (cents: number) => {
        return (cents / 100).toFixed(2);
    },
    convertDollarsToCents: (dollars: number) => {
        return Math.round(dollars * 100);
    },
};
